<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              @if (getAdditionalQuestions(parameters, 'CROWDFUNDING_FEES')) {
                <div class="row">
                  <div class="col col-md-12">
                    <pr-input-column label="Frais d’entrée" [derrors]="derrors">
                      <input
                        formControlName="crowdfundingFees"
                        type="number"
                        min="0"
                        max="100"
                        fraction="2"
                      />
                      <i>%</i>
                    </pr-input-column>
                  </div>
                </div>
              }
              @if (
                getAdditionalQuestions(
                  parameters,
                  'CROWDFUNDING_INCLUDE_FEES_IN_SUBSCRIPTION_AMOUNT'
                )
              ) {
                <div class="row mt">
                  <div class="col col-md-12">
                    <pr-input-radio
                      [derrors]="derrors"
                      formControlName="crowdfundingIncludeFeesInSubscriptionAmount"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Inclure des frais dans le montant de souscription"
                    >
                    </pr-input-radio>
                  </div>
                </div>
              }
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
